function LoadMore() {
  const loadmore = document.querySelector(".loadmore");
  const viewmore = document.querySelector(".viewmore");
  let ps_topic_attributes_parsed = JSON.parse(ps_topic_attributes);

  if (!loadmore && !viewmore) {
    return;
  }

  let anchorTag = viewmore.querySelector("a");
  let currentURL = window.location.href;
  // anchorTag.setAttribute("href", currentURL + "/paged/2");

  let loading = true;
  let total_page = -1;
  if (loadmore) {
    const is_video_subcat = loadmore.classList.contains("video-subcat");
    const is_video_landing = loadmore.classList.contains("video-landing");
    let url = `${pubstack.ajaxUrl}?action=infinite_scroll`;
    if (is_video_subcat || is_video_landing) {
      url = `${pubstack.ajaxUrl}?action=topic_scroll`;
    }
    if (is_video_subcat) {
      total_page = loadmore.getAttribute("data-total_page");
    }

    window.addEventListener(
      "scroll",
      (e) => {
        e.preventDefault();

        const scrollTop =
          (document.documentElement && document.documentElement.scrollTop) ||
          document.body.scrollTop;
        const clientHeight =
          document.documentElement.clientHeight || window.innerHeight;
        let bottomOffset = loadmore.offsetTop;
        let nextPage = loadmore.getAttribute("data-next_page");
        const { pagesToShow } = ps_topic_attributes_parsed;

        if (nextPage >= parseInt(pagesToShow)) {
          loading === false;
        }
        if (scrollTop > clientHeight - bottomOffset && loading === true) {
          loading = false;
          const input = {
            page: nextPage,
            attributes: ps_topic_attributes,
            post_id: pubstack.post_id,
            ad_count: document.querySelectorAll(
              ".ad-position.essence_incontent"
            ).length,
            is_video_iscroll: is_video_subcat || is_video_landing,
          };

          const loadmoreParams = Object.keys(input)
            .map((key) => {
              return (
                encodeURIComponent(key) + "=" + encodeURIComponent(input[key])
              );
            })
            .join("&");

          // Loading text
          loadmore.classList.toggle("hidden");

          const xhr = new XMLHttpRequest();
          xhr.addEventListener("load", function () {
            if (xhr.responseText) {
              loadmore.insertAdjacentHTML("beforebegin", xhr.responseText);
              if (true !== is_video_subcat) {
                jQuery(window).trigger("ad:scroll_update");
              }
              loadmore.classList.toggle("hidden");
              loading = true;

              nextPage++;
              loadmore.setAttribute("data-next_page", nextPage);

              let currentURL = window.location.href;
              let newURL = "";
              if (currentURL.includes("/paged/")) {
                newURL = currentURL.replace(
                  /(\/paged\/)[0-9]+/,
                  "/paged/" + nextPage
                );
              } else {
                newURL = currentURL + "/paged/" + nextPage;
              }

              const inputAttr = JSON.parse(input.attributes);
              const viewmoreURL = inputAttr.viewMoreLink;
              const viewmoreBase = viewmoreURL.replace(
                /(\?|\&)paged=\d+/g,
                "$1paged="
              );
              let viewmoreLink = viewmoreBase + nextPage;

              viewmore.querySelector("a").setAttribute("href", viewmoreLink);

              bottomOffset = loadmore.offsetTop;
              if (parseInt(nextPage) - 1 >= parseInt(pagesToShow)) {
                viewmore.classList.toggle("hidden");
                loading = false;
              }

              if (total_page !== -1 && nextPage > total_page) {
                loadmore.classList.add("hidden");
                viewmore.classList.add("hidden");
              }
            } else {
              loadmore.classList.toggle("hidden");
              loading = false;
            }
          });

          // Initiates POST request to WordPress admin-ajax.php endpoint
          xhr.open("POST", url);
          xhr.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded"
          );

          // Sends form POST data to open request to admin-ajax.php
          xhr.send(loadmoreParams);
        }
      },
      false
    );

    viewmore.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        let nextPage = loadmore.getAttribute("data-next_page");
        let viewmoreCounter = viewmore.getAttribute("data-counter");
        const { pagesToShow } = ps_topic_attributes_parsed;
        loading = false;
        viewmore.classList.toggle("hidden");
        debugger;
        viewmoreCounter++; //clicked... so let's increment..
        ps_topic_attributes_parsed["offset"] =
          ps_topic_attributes_parsed["postsToShow"] * viewmoreCounter;
        let anchorTag = viewmore.querySelector("a");
        let currentURL = window.location.href;
        let nextPageNum = viewmoreCounter + 3;
        let newURL = "";
        if (currentURL.includes("/paged/")) {
          newURL = currentURL.replace(/(\paged\/)[0-9]+/, "paged/" + nextPage);
        } else {
          newURL = currentURL.includes("?")
            ? currentURL + "paged/" + nextPage
            : currentURL + "paged/" + nextPage;
        }

        const viewmoreURL = ps_topic_attributes_parsed["viewMoreLink"];
        const viewmoreBase = viewmoreURL.replace(
          /(\?|\&)paged=\d+/g,
          "$1paged="
        );
        let viewmoreLink = viewmoreBase + nextPage;

        window.history.pushState({}, "", newURL);

        anchorTag.setAttribute("href", viewmoreLink);
        viewmore.setAttribute("data-counter", viewmoreCounter);

        const input = {
          page: nextPage,
          attributes: JSON.stringify(ps_topic_attributes_parsed),
          post_id: pubstack.post_id,
          ad_count: document.querySelectorAll("[id^='essence_incontent_']")
            .length,
          is_video_iscroll: is_video_subcat || is_video_landing,
        };

        const loadmoreParams = Object.keys(input)
          .map((key) => {
            return (
              encodeURIComponent(key) + "=" + encodeURIComponent(input[key])
            );
          })
          .join("&");

        // Loading text
        loadmore.classList.toggle("hidden");
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", function () {
          if (xhr.responseText) {
            loadmore.insertAdjacentHTML("beforebegin", xhr.responseText);

            if (true !== is_video_subcat) {
              jQuery(window).trigger("ad:scroll_update");
            }
            loadmore.classList.toggle("hidden");
            loading = true;

            nextPage++;
            loadmore.setAttribute("data-next_page", nextPage);

            if (
              parseInt(nextPage) - 1 >=
              parseInt(pagesToShow) * parseInt(viewmoreCounter)
            ) {
              viewmore.classList.toggle("hidden");
              // loadmore.insertAdjacentHTML("afterend", '<div class="more"><a href="'+viewMoreLink+'">View More</a></div>');
              loading = false;
            }

            if (total_page !== -1 && nextPage > total_page) {
              loadmore.classList.add("hidden");
              viewmore.classList.add("hidden");
            }
          } else {
            loadmore.classList.toggle("hidden");
            loading = false;
          }
        });

        // Initiates POST request to WordPress admin-ajax.php endpoint
        xhr.open("POST", url);
        xhr.setRequestHeader(
          "Content-Type",
          "application/x-www-form-urlencoded"
        );

        // Sends form POST data to open request to admin-ajax.php
        xhr.send(loadmoreParams);
      },
      false
    );
  }
}
export default LoadMore;
